"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createRegisteredShoppingList = void 0;
var create_registered_shopping_list_1 = require("./create-registered-shopping-list");
Object.defineProperty(exports, "createRegisteredShoppingList", { enumerable: true, get: function () { return create_registered_shopping_list_1.createRegisteredShoppingList; } });
